import React from 'react'
import PropTypes from 'prop-types'
import { Doughnut } from 'react-chartjs-2'
import get from 'lodash/get'
import styled from 'styled-components'
import { Container, Row, Col } from 'reactstrap'
import { FONTS } from '../../../constants'

class LeaveChartEntitlement extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { remain, pending, used, total } = this.props
    if (nextProps.remain !== remain
      || nextProps.pending !== pending
      || nextProps.used !== used
      || nextProps.total !== total) return true
    return false
  }

  render() {
    const remain = get(this.props, 'remain')
    const pending = get(this.props, 'pending')
    const used = get(this.props, 'used')
    const total = get(this.props, 'total')
    const header = `${get(this.props, 'header')} : ${total} Days`
    const data = {
      labels: [
        'Remaining',
        'Pending Approve',
        'Approved',
      ],
      datasets: [{
        data: [remain, pending, used],
        datalabels: {
          display: false,
        },
        fillColor: "#79D1CF",
        strokeColor: "#79D1CF",
        backgroundColor: [
          '#CCCCCC',
          '#FFD27C',
          '#333333',
        ],
        hoverBackgroundColor: [
          '#CCCCCC',
          '#FFD27C',
          '#333333',
        ],
      }],
    }
    const option = {
      cutoutPercentage: 70,
      legend: {
        display: false,
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        },
      },
    }
    return (
      <ChartContainer>
        <LabelRow noGutters >
          <LabelChart>{ header }</LabelChart>
        </LabelRow>
        <ChartRow noGutters >
          <ColInfo>
            <FirstCon >
              <RowContent>
                <TypeLabel>Remaining</TypeLabel>
              </RowContent>
              <RowContent>
                <NumLabel>{ remain }</NumLabel>
              </RowContent>
            </FirstCon>
            <SecondCon>
              <RowContent>
                <TypeLabel>Pending Approve</TypeLabel>
              </RowContent>
              <RowContent>
                <NumLabel> { pending }</NumLabel>
              </RowContent>
            </SecondCon>
            <ThirdCon>
              <RowContent>
                <TypeLabel>Approved</TypeLabel>
              </RowContent>
              <RowContent>
                <NumLabel>{ used }</NumLabel>
              </RowContent>
            </ThirdCon>
          </ColInfo>
          <ColChart>
            <DivChart>
              <Doughnut data={ data } options={ option } height={ 180 } />
            </DivChart>
          </ColChart>
        </ChartRow>
      </ChartContainer>
    )
  }
}

LeaveChartEntitlement.propTypes = {
  remain: PropTypes.number,
  pending: PropTypes.number,
  used: PropTypes.number,
  total: PropTypes.number,
}
LeaveChartEntitlement.defaultProps = {
  remain: 0,
  pending: 0,
  used: 0,
  total: 0,
}

export default LeaveChartEntitlement

const ChartContainer = styled(Container)`
  height: 100% ;
  margin-bottom: 0px;
  margin-left: 0px;
  background:#FFFFFF;
  -moz-box-shadow: 1px 2px 4px rgba(0, 0, 0,0.16);
  -webkit-box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .16);
`
const LabelRow = styled(Row)`
  width: 100%;
  height: 20% ;
  padding-top: 5%;
`
const ChartRow = styled(Row)`
  width: 100%;
  height: 80%;
`
const LabelChart = styled.label`
  font-size: ${FONTS.SMALL_SIZE};
  margin-left: 5%;
  font-family: ${FONTS.GOTHAM_MEDIUM};
`
const ColInfo = styled(Col)`
  width: 40%;
  height: 100%;
  padding-top: 10px;
`
const ColChart = styled(Col)`
  width: 60%;
  height: 100%;
`
const FirstCon = styled(Container)`
  margin-left: 10%;
  margin-bottom: 15%;
  padding-left: 5%;
  border-left: 8px solid #CCCCCC;
`
const SecondCon = styled(Container)`
  margin-left: 10%;
  margin-bottom: 15%;
  padding-left: 5%;
  border-left:8px solid #FFD27C;
`
const ThirdCon = styled(Container)`
  margin-left: 10%;
  margin-bottom: 15%;
  padding-left: 5%;
  border-left: 8px solid #333333;
`
const TypeLabel = styled.label`
  font-family: ${FONTS.GOTHAM};
  color: #7B7B7B ;
  font-size : ${FONTS.SMALL_SIZE};
  margin-bottom: 0%;
`
const NumLabel = styled.label`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size : ${FONTS.SMALL_SIZE};
  margin-bottom: 0%;
`
const DivChart = styled.div`
  width: 100%;
  height: 100% ;
  padding-top: 5% ;
  z-index:1;
`
const RowContent = styled(Row)`
  margin-left: 2%;
`



// WEBPACK FOOTER //
// ./src/components/my-leave/chart/leave-entitlement.js